import api from './api.js';

class Products {
    constructor(){
        this.url_products = 'Products'
    }
    get(id){
        return api.get(`${this.url_products}/${id}`);
    }
    getImage(data){
        return api.get(`${this.url_products}/ThumbnailURL?mfgId=${data.MfgId}&stockCode=${data.StockCode}`)
    }
    getDataSource(id){
        return api.getDataSource(this.url_products, id);
    }
    all(){
      return api.get(`${this.url_products}/`);
    }
    getByStockCode(stockCode){
        return api.get(`${this.url_products}/StockCode/${stockCode}`)
    }
    getByCode(prodData){
        let partNumber = encodeURIComponent(prodData.PartNumber);
        // console.log('part number', partNumber, encodeURIComponent('CMT20+'))
        // console.log('hey,', `${this.url_products}/PartNumber?MfgId=${prodData.MfgId}&PartNumber=${encodeURIComponent(partNumber)}`)
        return api.get(`${this.url_products}/PartNumber?MfgId=${prodData.MfgId}&PartNumber=${partNumber}`);
    }
    create(data){
        return api.put(`${this.url_products}/`, data);
    }
    update(data){
        return api.put(`${this.url_products}/${data.Id}`, data);
    }
    delete(id){
        return api.delete(`${this.url_products}/${id}`);
    }
}

export default new Products;
